(function () {
  var toast = document.getElementById('toast'), t;

  function say(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('on');
    clearTimeout(t);
    t = setTimeout(function () { toast.classList.remove('on'); }, 2400);
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = document.getElementById('cartN');
        if (el) el.textContent = c.item_count;
      })
      .catch(function () {});
  }

  // Größe wählen
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.size');
    if (!b || b.disabled) return;
    var group = b.closest('.sizes');
    group.querySelectorAll('.size').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    b.setAttribute('aria-pressed', 'true');
    var pr = document.getElementById('pPrice');
    if (pr && b.dataset.price) pr.textContent = b.dataset.price;
  });

  // In den Warenkorb
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add');
    if (!btn || btn.disabled) return;

    var card = btn.closest('[data-name]');
    var scope = btn.closest('.card-body') || card || document;
    var sel = scope.querySelector('.size[aria-pressed="true"]') ||
              (card && card.querySelector('.size[aria-pressed="true"]'));

    if (!sel) { say('Bitte erst eine Größe wählen'); return; }

    var id = sel.dataset.variant;
    if (!id) { say('Diese Variante fehlt im Shop'); return; }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Moment…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          say(res.d.description || 'Das hat nicht geklappt');
          return;
        }
        var name = card ? card.dataset.name : 'Artikel';
        say(name + ' · ' + sel.textContent.trim() + ' liegt im Warenkorb');
        refreshCount();
      })
      .catch(function () { say('Keine Verbindung zum Warenkorb'); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });

  // Scroll-Reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -60px' });
    document.querySelectorAll('.rv').forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  // Im Theme-Editor neu initialisieren
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  });
})();
